import { FoodOrderDeliveryType } from "../../server/Types"

export class OrderProximity {

  private static readonly MAX_DISTANCE_KM: Record<string, number> = {
    [FoodOrderDeliveryType.Table]: 5,
    [FoodOrderDeliveryType.PickUp]: 10,
  }

  private static readonly EARTH_RADIUS_KM = 6371
  private static readonly DEGREES_TO_RADIANS = Math.PI / 180
  private static readonly HALF_ANGLE_DIVISOR = 2

  public static getMaxDistanceKm = (deliveryType: string): number | null =>
    OrderProximity.MAX_DISTANCE_KM[deliveryType] ?? null

  public static getDistanceKm = (
    fromLatitude: number,
    fromLongitude: number,
    toLatitude: number,
    toLongitude: number
  ): number => {
    const latitudeDelta = (toLatitude - fromLatitude) * OrderProximity.DEGREES_TO_RADIANS
    const longitudeDelta = (toLongitude - fromLongitude) * OrderProximity.DEGREES_TO_RADIANS
    const fromLatitudeRadians = fromLatitude * OrderProximity.DEGREES_TO_RADIANS
    const toLatitudeRadians = toLatitude * OrderProximity.DEGREES_TO_RADIANS

    const halfChordSquared =
      Math.sin(latitudeDelta / OrderProximity.HALF_ANGLE_DIVISOR) ** 2 +
      Math.cos(fromLatitudeRadians) * Math.cos(toLatitudeRadians) * Math.sin(longitudeDelta / OrderProximity.HALF_ANGLE_DIVISOR) ** 2
    const angularDistance = OrderProximity.HALF_ANGLE_DIVISOR * Math.atan2(Math.sqrt(halfChordSquared), Math.sqrt(1 - halfChordSquared))
    return OrderProximity.EARTH_RADIUS_KM * angularDistance
  }
}
